
import { Getter, State } from 'vuex-class';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class PageTop extends Vue {
  @State(state => state.uiEnvVersion) private uiEnvVersion!: string|null;
}
